import { Platform } from '@ionic/angular';
import { mygolfUtils } from './../../../custom/mygolf2u-utils';
import { Router } from '@angular/router';
// import { NavController } from "@ionic/angular/index";
import { ContactUsPage, HelpURLs } from '../contact-us/contact-us.page';
import { Component, OnInit } from '@angular/core';
import { ClubFlightService } from '../../../providers/club-flight-service/club-flight-service';
import { Location } from '@angular/common';
import * as global from 'globals';
import { Browser } from '@capacitor/browser';

/**
 * Created by Ashok on 29-03-2016.
 */
@Component({
  templateUrl: 'settings.page.html',
  selector: 'settings-page',
  styleUrls: ['settings.page.scss'],
})
export class SettingsPage implements OnInit {
  helpURL: string;

  constructor(
    private Location: Location,
    private router: Router,
    private flightService: ClubFlightService,
    private mg2uUtil: mygolfUtils,
    private platform: Platform
  ) {}

  ngOnInit() {
    // this.refreshHelpUrl();
  }

  refreshHelpUrl() {
    this.flightService.getHelp().subscribe(
      (helpURL: Array<HelpURLs>) => {
        if (helpURL && helpURL.length > 0) {
          // && helpURL.length > 0
          this.helpURL = helpURL[0].url;
        }
        // else this.helpURL = 'http://portal.mygolf2u.com/document/help-contents/mobile/help_content.html'
      },
      error => {},
      () => {}
    );
  }

  enableSettings: any = {};
  callHelpPage() {
    const _helpAttr = this.mg2uUtil.getSettingsAttribute();
    const _isClubSpecific = this.mg2uUtil.getClubSpecific();
    console.debug('settings page : ', _helpAttr, _isClubSpecific, global.clubId);
    if (_helpAttr) {
      if (_isClubSpecific) {
        const hasClubSettings = _helpAttr.clubSpecific
          .filter(c => {
            return c.clubId === global.clubId;
          })
          .map(c => {
            // this.showSettings = c.showSettings;
            this.enableSettings = c.enableSettings;
          });
      } else {
        // this.showSettings = this.appAttribute.main.showSettings;
        this.enableSettings = _helpAttr.main.enableSettings;
      }
    }
    if (!this.enableSettings || (this.enableSettings && !this.enableSettings.help)) {
      return;
    }
    // if(this.mg2uUtil.getClubSpecific) return;
    let _helpJson;

    if (_isClubSpecific && global.appType && global.clubId) {
      const hasClubSpec = _helpAttr.clubSpecific.filter(c => {
        return c.clubId === global.clubId;
      });
      console.debug('settings page : ', hasClubSpec, global.clubId);
      if (hasClubSpec?.length) {
        hasClubSpec.map(c => {
          _helpJson = c.helpPage;
        });
      } else {
        _helpJson = _helpAttr.main.helpPage;
      }
    } else {
      _helpJson = _helpAttr.main.helpPage;
    }
    this.flightService.getHelp(_helpJson).subscribe(
      (helpURL: Array<HelpURLs>) => {
        console.debug('settings page : get help json', _helpJson, _helpAttr, helpURL);
        if (helpURL && helpURL.length > 0) {
          // && helpURL.length > 0
          this.helpURL = helpURL[0].url;

          const _url = this.helpURL;
          if (this.platform.is('capacitor')) {
            Browser.open({ url: _url });
          } else {
            let win = window.open(_url, '_system');
          }
          // console.log('get help url items', this.helpURL);
          // window.open(this.helpURL, '_system');
        }
        // else this.helpURL = 'http://portal.mygolf2u.com/document/help-contents/mobile/help_content.html'
      },
      error => {},
      () => {}
    );
    // ! OLD code
    // this.flightService.getHelp().subscribe(
    //   (helpURL: any) => {
    //     if (helpURL && helpURL.length > 0) {
    //       // && helpURL.length > 0
    //       this.helpURL = helpURL[0].url;

    //       window.open(this.helpURL, '_self');
    //     }
    //     // else this.helpURL = 'http://portal.mygolf2u.com/document/help-contents/mobile/help_content.html'
    //   },
    //   error => {},
    //   () => {}
    // );
  }
  gotopage(Pagename) {
    this.router.navigate([Pagename]);
  }

  back() {
    this.Location.back();
  }
}
